// extracted by mini-css-extract-plugin
export var orderSummary = "_qm-0";
export var showMoreLessButton = "_qm-1";